import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { productSelector } from 'selectors/page/product/productSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import HighlyRatedForEN from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/locales/HighlyRatedFor_en_US';
import HighlyRatedForFR from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/locales/HighlyRatedFor_fr_CA';
import productPageSOTBindings from 'analytics/bindingMethods/pages/productPage/productPageSOTBindings';
import productActions from 'actions/ProductActions';
import { isGenAIPRSEnabledSelector } from 'ai/selectors/killSwitches/isGenAIPRSEnabledSelector';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(HighlyRatedForEN, HighlyRatedForFR);

const fields = createSelector(
    productSelector,
    createStructuredSelector({
        seeMore: getTextFromResource(getText, 'seeMore'),
        linkLead: getTextFromResource(getText, 'linkLead'),
        linkLeadRedesign: getTextFromResource(getText, 'linkLeadRedesign'),
        modalTitle: getTextFromResource(getText, 'modalTitle')
    }),
    isGenAIPRSEnabledSelector,
    (product, localization, isGenAIPRSEnabled) => {
        return {
            product,
            localization,
            isGenAIPRSEnabled
        };
    }
);

const functions = {
    highlyRatedForClick: productPageSOTBindings.highlyRatedForClick,
    loadHighlightedReviews: productActions.loadHighlightedReviews
};

const withHighlyRatedForProps = wrapHOC(connect(fields, functions));

export {
    withHighlyRatedForProps, fields, functions
};
